// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wMff","textarea":"styles_textarea__2xz48"};